// 请求拦截器，在 login 和 signup 之前上报设备指纹
import request from '@tools/request';
import _ from 'lodash';
import remoteEvent from '@tools/remoteEvent';

let Report = null;

remoteEvent.emit(remoteEvent.evts.GET_REPORT, (_Report) => {
  Report = _Report;
});

const FINGERPRINT_URLS = [
  {
    url: '/ucenter/aggregate-login',
    event: 'login',
  },
  {
    url: '/ucenter/sign-up-email',
    event: 'register',
  },
  {
    url: '/ucenter/sign-up-phone',
    event: 'register',
  },
  {
    url: '/ucenter/login-validation',
    event: 'login-validation',
  },
  {
    url: '/ucenter/login-verify/resend',
    event: 'login-verify-resend',
  },
];

const fingerprintInterceptor = async (config) => {
  const urlMatch = _.find(FINGERPRINT_URLS, (o) => config.url.startsWith(o.url));
  if (urlMatch && Report) {
    const token = await Report.logFingerprint(urlMatch.event);
    config.headers = {
      ...config.headers,
      TOKEN: token,
    };
  }
  return config;
};

request.interceptors.request.use(fingerprintInterceptor);
